import React from 'react';
import PropTypes from 'prop-types';
import ASQSurveysHeader from './ASQSurveysHeader';
import ASQSurveysRow from './ASQSurveysRow';
import InfiniteScroll from 'react-infinite-scroller';
import { flatten, isEmpty } from 'lodash';
import { tableNoResults, tableSpinner } from '../helpers/TableHelpers';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { ANIMATIONS } from 'utils/Animations';

export default class ASQSurveysTable extends React.Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    download: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired,
    isFetching: PropTypes.bool.isRequired,
    location: PropTypes.object.isRequired,
    meta: PropTypes.object.isRequired,
    onASQLink: PropTypes.func.isRequired,
    onDownloadASQReport: PropTypes.func.isRequired,
    onLoadMore: PropTypes.func.isRequired,
    onPlayerDetails: PropTypes.func.isRequired,
    onSortChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    surveys: PropTypes.arrayOf(PropTypes.object).isRequired,
    totalPages: PropTypes.number.isRequired,
  }

  onLoadMore = () => {
    this.props.onLoadMore(this.props.page + 1);
  }

  shouldComponentUpdate(nextProps) {
    return !nextProps.isFetching;
  }

  render() {
    const {
      auth, download, isLoading, isFetching, location, meta,
      page, totalPages, surveys, onASQLink, onDownloadASQReport, onPlayerDetails, onSortChange,
    } = this.props;
    const rows = flatten(
      surveys.map(
        (s, i) =>
          <CSSTransition key={`${s.id}-${i}`} timeout={{ enter: ANIMATIONS.in, exit: 0 }} classNames='a-fade'>
            <ASQSurveysRow meta={meta} auth={auth} player={s} playerIdx={i} download={download} onDownloadASQReport={onDownloadASQReport}
              onASQLink={onASQLink} onPlayerDetails={onPlayerDetails} location={location} />
          </CSSTransition>
      )
    );

    if (isLoading) {
      return (
        <div className='o-rtable o-rtable--bordered u-margin-bottom--gutter2x'>
          <ASQSurveysHeader auth={auth} meta={meta} onSortChange={onSortChange} />
          { tableSpinner() }
        </div>
      );
    }

    if (!isLoading && isEmpty(surveys)) {
      return (
        <div className='o-rtable o-rtable--bordered u-margin-bottom--gutter2x'>
          <ASQSurveysHeader auth={auth} meta={meta} onSortChange={onSortChange} />
          { tableNoResults() }
        </div>
      );
    }

    return (
      <div className='o-rtable o-rtable--bordered u-margin-bottom--gutter2x'>
        <ASQSurveysHeader auth={auth} meta={meta} onSortChange={onSortChange} />
        <InfiniteScroll
          pageStart={0}
          loadMore={this.onLoadMore}
          hasMore={page < totalPages && !isFetching}
          loader={tableSpinner()}
          initialLoad={false}
          useWindow={true}>
          <TransitionGroup exit={false}>
            {rows}
          </TransitionGroup>
        </InfiniteScroll>
      </div>
    );
  }
}
